import Marquee from "react-fast-marquee";
import { useReducedMotion } from "framer-motion";
import { BRANDS, FEATURED_BRAND, COPY } from "@/lib/site";
import { Reveal } from "./Motion";

const Item = ({ name, featured }) => (
  <span
    className={`mx-6 md:mx-10 font-display leading-none whitespace-nowrap ${
      featured
        ? "text-ink text-4xl md:text-6xl italic"
        : "text-ink/55 text-3xl md:text-5xl"
    }`}
  >
    {name}
    <span className="mx-6 md:mx-10 align-middle text-clay/40 text-2xl md:text-3xl not-italic">
      ·
    </span>
  </span>
);

export const Brands = () => {
  const reduce = useReducedMotion();
  const half = Math.ceil(BRANDS.length / 2);
  const rowA = [FEATURED_BRAND, ...BRANDS.slice(0, half)];
  const rowB = BRANDS.slice(half);

  return (
    <section id="brands" data-testid="brands-section" className="grain py-24 md:py-36 overflow-hidden">
      <div className="container-editorial">
        <Reveal className="max-w-3xl mb-14 md:mb-20">
          <p className="kicker mb-6">{COPY.brands.kicker}</p>
          <h2 className="font-display text-5xl md:text-7xl leading-[0.95] tracking-tight">
            {COPY.brands.heading}
          </h2>
          <p className="mt-6 text-base md:text-lg font-light text-ink/70 leading-relaxed">
            {COPY.brands.sub}
          </p>
        </Reveal>

        {/* Featured collaboration — KFC India.
            Typography-only by design: no verified KFC-specific photograph exists,
            so no image is associated with this brand. */}
        <Reveal
          data-testid="featured-brand"
          className="mb-14 md:mb-20 border border-line rounded-sm p-10 md:p-16 bg-surface/50"
        >
          <p className="kicker mb-8 md:mb-10">{COPY.brands.featuredLabel}</p>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center">
            <div className="md:col-span-7">
              <div className="font-display text-7xl sm:text-8xl md:text-[8.5rem] leading-[0.82] tracking-tight">
                {FEATURED_BRAND}
              </div>
            </div>
            <div className="md:col-span-5 md:border-l md:border-line md:pl-12">
              <span className="block w-12 h-px bg-clay/50 mb-6 md:hidden" aria-hidden="true" />
              <p className="max-w-sm text-base md:text-lg font-light text-ink/70 leading-relaxed">
                {COPY.brands.featuredCopy}
              </p>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="space-y-6 md:space-y-8 py-4 select-none" aria-hidden="true">
        <Marquee speed={reduce ? 0 : 34} gradient={false} pauseOnHover>
          {rowA.map((b) => (
            <Item key={b} name={b} featured={b === FEATURED_BRAND} />
          ))}
        </Marquee>
        <Marquee speed={reduce ? 0 : 34} direction="right" gradient={false} pauseOnHover>
          {rowB.map((b) => (
            <Item key={b} name={b} />
          ))}
        </Marquee>
      </div>

      {/* accessible list for screen readers / SEO */}
      <ul className="sr-only">
        <li>{FEATURED_BRAND}</li>
        {BRANDS.map((b) => (
          <li key={b}>{b}</li>
        ))}
      </ul>
    </section>
  );
};
